<form class="dynamic-collapse-owners-list" *ngIf="ownersList && ownersList.length>=2">
  <!-- Joint Owners -->
  <div class="joint-owners-list row">
    <header class="header">
      <div class="owner-name col-sm-4">Owner</div>
      <div class="ownership-type col-sm-4">
        <span>Ownership Type</span>
      </div>
      <div *ngIf="ownershipTypeSelected=='common'" class="share-ownership col-sm-4">Ownership % Share</div>
    </header>
    <ng-container *ngFor="let item of ownersList; let y = index">
      <main class="main">
        <div class="owner-name col-sm-4">
          {{item.owner.first + " " + item.owner.last}}
        </div>
        <select class="col-sm-4" (change)="checkOwnerType(ownershipTypeSelected)" [(ngModel)]="ownershipTypeSelected"
          [ngModelOptions]="{standalone: true}">
          <option *ngFor="let type of ownershipTypeList" [ngValue]="type.value">{{type.type}}</option>
          <!-- <option value="joint">Joint tenant</option>
          <option value="common">Tenant in common</option> -->
        </select>

        <div class="col-sm-4" *ngIf="ownershipTypeSelected=='common'">
          <label class="label" for="{{fieldId}}">
            <input class="form-control floating-input" (input)="checkOwnerShare(item.share)" [(ngModel)]="item.share"
              [ngModelOptions]="{standalone: true}" placeholder=" " type="number" min="0" max="10000000000"
              [ngClass]="{'is-invalid': invalid}" />
            <span class="highlight"></span>
          </label>
        </div>
      </main>
    </ng-container>
    <div class="error-message" *ngIf="errorMessage">Total ownership must equal precisely 100 percent.</div>
  </div>
</form>